import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Container, Table, Button } from "react-bootstrap";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import { apiGetEmissions, apiUpdateEmissions } from "../../api/ApiEmission";
import { MdOutlineEdit, MdDeleteOutline, MdAddCircleOutline, MdDone } from "react-icons/md";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import { AiOutlineAudio, AiOutlineVideoCamera } from "react-icons/ai";
import ModalCreateUpdate from "../../components/admin/video/ModalCreateUpdate";
import ComponentLoader from "../../components/layout/ComponentLoader";
import ModalDelete from "../../components/admin/video/ModalDelete";

const PageAdminEmission = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [showCreateUpdate, setShowCreateUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const [prochainIndice, setProchainIndice] = useState(0);
  const [order, setOrder] = useState(false);
  const [loader, setLoader] = useState(false);
  const [idEmission, setIdEmission] = useState("");
  const [emissions, setEmissions] = useState([]);

  const handleShowCreateUpdate = (id) => {
    setIdEmission(id);
    setShowCreateUpdate(true);
  };
  const handleCloseCreateUpdate = () => {
    setIdEmission(null);
    setShowCreateUpdate(false);
  };

  const handleShowDelete = (id) => {
    setIdEmission(id);
    setShowDelete(true);
  };
  const handleCloseDelete = () => {
    setIdEmission(null);
    setShowDelete(false);
  };

  const changeOrdre = (index, sens) => {
    setOrder(true);
    const emissionsCopy = [...emissions];
    const elementSauvegarde = emissionsCopy[index];
    if (sens === "haut") {
      if (index !== 0) {
        emissionsCopy[index] = emissionsCopy[index - 1];
        emissionsCopy[index - 1] = elementSauvegarde;
      }
    }
    if (sens === "bas") {
      if (index !== emissions.length - 1) {
        emissionsCopy[index] = emissionsCopy[index + 1];
        emissionsCopy[index + 1] = elementSauvegarde;
      }
    }
    setEmissions(emissionsCopy);
  };

  const SubmitData = async () => {
    setOrder(false);
    setLoader(true);
    const emissionsCopy = [...emissions].reverse();
    emissionsCopy.forEach((emission, index) => {
      emission.ordre = index;
    });
    await apiUpdateEmissions(emissionsCopy);
    setEmissions(emissionsCopy.reverse());
    recupVideos();
    setLoader(false);
  };

  const recupVideos = async () => {
    const res = await apiGetEmissions(ReduxInstance._id, "sort[ordre]=-1");
    if (res.data[0]) {
      setProchainIndice(res.data[0].ordre + 1);
      setEmissions(res.data);
    }
  };

  useEffect(() => {
    recupVideos();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminMedias.titre")} />
        <span role="button" onClick={() => handleShowCreateUpdate("")}>
          <MdAddCircleOutline size="1.5em" /> {t("admin.PageAdminMedias.ajouter")}
        </span>
        <Table striped bordered hover className="stickyTable mt-2">
          <thead>
            <tr>
              <th>{t("admin.PageAdminMedias.titreColonne1")}</th>
              <th>{t("admin.PageAdminMedias.titreColonne2")}</th>
              <th>{t("admin.PageAdminMedias.titreColonne3")}</th>
              <th className="text-center">{t("admin.PageAdminMedias.titreColonne4")}</th>
              <th className="text-center">{t("admin.PageAdminMedias.titreColonne5")}</th>
              <th className="text-center">{t("admin.PageAdminMedias.titreColonne6")}</th>
            </tr>
          </thead>
          <tbody>
            {emissions.map((emission, index) => (
              <tr key={index}>
                <td>
                  <TiArrowSortedUp
                    size="1.5em"
                    role="button"
                    onClick={(e) => changeOrdre(index, "haut")}
                  />
                  <TiArrowSortedDown
                    size="1.5em"
                    role="button"
                    onClick={(e) => changeOrdre(index, "bas")}
                  />
                  {emission.nom}
                </td>
                <td>
                  <a href={emission.URL} target="_blank" rel="noreferrer">
                    {emission.URL}
                  </a>
                </td>
                <td className="text-center">
                  {emission.type === "podcast" && <AiOutlineAudio size="1.5em" />}
                  {emission.type === "emission" && <AiOutlineVideoCamera size="1.5em" />}
                </td>
                <td className="text-center">{emission.publie && <MdDone size="1.5em" />}</td>
                <td className="text-center">
                  <MdOutlineEdit
                    size="1.5em"
                    role="button"
                    onClick={() => handleShowCreateUpdate(emission._id, emission.nom)}
                  />
                </td>
                <td className="text-center">
                  <MdDeleteOutline
                    size="1.5em"
                    role="button"
                    onClick={() => handleShowDelete(emission._id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {order && (
          <div className="text-end mb-5">
            {loader && <ComponentLoader />}
            <Button variant="success" type="Submit" onClick={(e) => SubmitData()}>
              {t("commun.form.button.enregistrerOrdre")}
            </Button>
          </div>
        )}
        <ModalCreateUpdate
          show={showCreateUpdate}
          id={idEmission}
          handleClose={handleCloseCreateUpdate}
          handleRecupDatas={recupVideos}
          prochainIndice={prochainIndice}
        />
        <ModalDelete
          show={showDelete}
          id={idEmission}
          handleClose={handleCloseDelete}
          handleRecupDatas={recupVideos}
        />
      </Container>
    </>
  );
};

export default PageAdminEmission;
